import {
  AccountingEventsGroup,
  DigitalBusinessDocument,
  DigitalCostDocument,
} from "../types";
import { isDigitalBusinessDocument, isDigitalDocument } from "./typeChecks";
import { FlowType } from "../hooks/useFlowType";

export function shouldHideAccountingFlow(
  events: (
    | AccountingEventsGroup
    | DigitalBusinessDocument
    | DigitalCostDocument
  )[],
  contextGlProduct?: string | number
): boolean {
  const hasDocumentEvents = events.some((event) => isDigitalDocument(event));
  const hasValidBusinessDocumentEvents = events.some((event) =>
    hasValidBusinessDocumentEvent(event)
  );

  const documentRevenueBookedViaAccountingGroup =
    events.some((event) => isRevenueBookingDisabled(event)) ||
    !hasValidBusinessDocumentEvents;

  return !documentRevenueBookedViaAccountingGroup && hasDocumentEvents;
}

export function shouldHideDocumentFlow(
  events: (
    | AccountingEventsGroup
    | DigitalBusinessDocument
    | DigitalCostDocument
  )[]
): boolean {
  return !events.some((event) => isDigitalDocument(event));
}

const hasValidBusinessDocumentEvent = (
  event: AccountingEventsGroup | DigitalBusinessDocument | DigitalCostDocument
) => {
  if (isDigitalBusinessDocument(event)) {
    const { payments } = event.body.body;
    return !!payments && Object.entries(payments).length > 0;
  }
  return false;
};

const isRevenueBookingDisabled = (
  event: AccountingEventsGroup | DigitalBusinessDocument | DigitalCostDocument
) => {
  return (
    isDigitalBusinessDocument(event) &&
    (event.body.metadata.internalAttributes?.REVENUE_BOOKINGS_DISABLED || false)
  );
};

// These display names are used for health status steps, they only show when both flows are present for an order
export function getFlowDisplayName(flowType: FlowType): string {
  switch (flowType) {
    case "document":
      return "Royalty Flow"; // If there is document + accounting flow, then document is used for royalties
    case "accounting":
      return "Revenue Flow";
    default:
      return "Unknown Flow";
  }
}
